import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchDeleteContactFailure,
  fetchDeleteContactSuccess,
} from "../slices/features/deleteContact";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* deleteContactSaga(action: any) {
  const { payload } = action;
  const { id, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.deleteContact,
      baseUrl,
      id,
      meta
    );

    yield put(fetchDeleteContactSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchDeleteContactFailure({ statusCode, statusText }));
  }
}

export function* watchDeleteContact() {
  yield takeLatest(RequestTypes.DELETE_CONTACT_REQUEST, deleteContactSaga);
}
